import script from "./FastGridTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FastGridTable.vue?vue&type=script&setup=true&lang=js"

import "./FastGridTable.vue?vue&type=style&index=0&id=6704cb3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6704cb3e"]])

export default __exports__